/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import Modal from "react-responsive-modal";
import DifferenceComponent from "../../../admin/test-dashboard/difference/difference";

// Interface for component Props
interface DifferencePopupProps {
  open: boolean;
  close: () => void;
  t?: any;
  questionType?: string;
  initialInput: any;
  initialResults: any;
}

// Interface for component State
interface DifferencePopupState { }

/**
 * Difference check this popup component.
 *
 * @namespace DifferencePopup
 */

class DifferencePopup extends Component<
  DifferencePopupProps,
  DifferencePopupState
> {
  constructor(props: DifferencePopupProps) {
    super(props);
  }
  handleOnKeyPress = (event: any) => {
    if (event.key === "Enter" || event.key === " ") {
      this.props.close();
    }
  };
  render() {
    const { open, questionType, initialInput, initialResults } = this.props;
    return (
      <div>
        <Modal
          open={open}
          onClose={this.props.close}
          center
          classNames={{
            overlay: "custom-overlay",
            modal: "modal-container difference-check-modal",
            closeButton: "hide",
          }}
        >
          <div className="popup-wrapper">
            <div className="popup-header-container">
              <div
                tabIndex={0}
                role="button"
                className="popup-close-icon"
                onClick={this.props.close}
                onKeyPress={this.handleOnKeyPress}
              >
                <span className="icon close-icon"></span>
              </div>
            </div>
            <div className="popup-inner-wrapper">
              <DifferenceComponent
                initialInput={initialInput}
                initialResults={initialResults}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default DifferencePopup;
